export const status = ['全部', '现货'];
export const a = 1;
